import { TCIconsName } from 'components';
import { routePaths } from './routes';

interface IMenuItems {
  path: string;
  label: string;
  iconName: TCIconsName;
  userType?: 'admin' | 'client';
  isLast?: boolean;
  disabled?: boolean;
  aIconName?: TCIconsName;
  noParticipant?: boolean;
}
export const menuItems: IMenuItems[] = [
  {
    path: routePaths.home,
    label: 'Início',
    iconName: 'home_alt',
    aIconName: 'home',
    noParticipant: true,
  },
  {
    path: routePaths.functions,
    label: 'Todas Funções',
    iconName: 'squares_alt',
    noParticipant: true,
  },
  {
    path: routePaths.demands,
    label: 'Solicitações',
    iconName: 'user_gear_alt',
    userType: 'admin',
  },
  {
    path: '',
    label: 'Clientes',
    iconName: 'user_alt',
    userType: 'admin',
    disabled: true,
  },
  {
    path: 'pdf',
    label: 'Conheça a LGPD',
    iconName: 'bookmark_alt',
  },
  {
    path: '',
    label: 'Portal Daniel',
    iconName: 'share_alt',
    isLast: true,
    disabled: true,
  },
  {
    path: routePaths.terms,
    label: 'Termo de Uso e Privacidade',
    iconName: 'document_alt',
    isLast: true,
  },
];
